import axios from "axios";
class HttpService {
  constructor(baseURL = process.env.VUE_APP_API_BASE_URL) {
    this.instance = axios.create({
      baseURL,
      headers: {
        "Content-Type": "application/json",
      },
    });

    this._setupInterceptors();
  }

  _getTokenFromUrl() {
    const params = new URLSearchParams(window.location.search);
    return params.get("token");
  }

  _setupInterceptors() {
    this.instance.interceptors.request.use(
      (config) => {
        const token = this._getTokenFromUrl();

        if (token) {
          config.headers["Token"] = token;
        }

        return config;
      },
      (error) => Promise.reject(error),
    );

    this.instance.interceptors.response.use(
      (response) => response,
      (error) => Promise.reject(error.response || error),
    );
  }

  get(url, params = {}, config = {}) {
    return this.instance.get(url, { params, ...config });
  }

  post(url, data = {}, config = {}) {
    return this.instance.post(url, data, config);
  }

  put(url, data = {}, config = {}) {
    return this.instance.put(url, data, config);
  }

  patch(url, data = {}, config = {}) {
    return this.instance.patch(url, data, config);
  }

  delete(url, config = {}) {
    return this.instance.delete(url, config);
  }
}

export default new HttpService();
